import InstantLuckyDrawPage from './instantLuckyDraw.container'

export default InstantLuckyDrawPage